<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'80%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-progress-circular v-if="loadingUserInfo" indeterminate :color="Theme.PINK"></v-progress-circular>
        <span v-if="userInfo" class="font-weight-bold">目前紅利與營收比：<span style="color: red"> {{ userInfo.alreadyUseBonus }} </span> (餘額不足時無法設定商品紅利！)</span>
        <v-tabs class="mb-2"
            v-model="tab"
            :color="Theme.GREEN">
          <v-tab :value="0">商品資訊</v-tab>
          <v-tab :value="1">商品圖片</v-tab>
          <v-tab :value="2">檢視抽況</v-tab>
          <v-tab :value="3">獎品設定</v-tab>
          <v-tab :value="4">賞籤設定</v-tab>
          <v-tab :value="5" v-if="event === 'edit' && itemDetail.category !==3">多抽優惠設定</v-tab>
          <v-tab :value="6" v-if="event === 'edit' && (isAdmin || isStaff || userInfo.enableSendGift === true)">手動贈獎</v-tab>
          <v-tab :value="7" v-if="event === 'edit' && isAdmin && (itemDetail.category !==3 || itemDetail.category !==5)">價格區間</v-tab>
          <v-tab :value="8">近期瀏覽</v-tab>
          <v-tab :value="9" v-if="isAdmin">Boss 設定</v-tab>
        </v-tabs>

        <div v-if="tab === 0">
          <v-layout>
            <span class="mt-1" :style="`color: ${Theme.RED}`">出貨時間請盡量在14天內，不可上架超過一個月的預購商品！</span>
          </v-layout>
          <v-layout v-for="col in getDialogKeys" :key="col.value">
            <v-flex>
              <v-textarea v-if="col.value === 'comment'" :counter="col.max" :label="col.text" :color="Theme.GREEN"
                          v-model="itemDetail[col.value]"/>
              <v-select v-else-if="col.value === 'subtype'"
                        :color="Theme.GREEN"
                        :items="selectSubtypeList"
                        :label="col.value"
                        item-text="value" item-value="key"
                        v-model="itemDetail[col.value]"/>

              <v-radio-group v-else-if="col.isRadio" :label="col.text" v-model="itemDetail[col.value]" row>
                <v-radio label="現貨" value="現貨"></v-radio>
                <v-radio label="追加" value="追加"></v-radio>
                <v-radio label="預購" value="預購"></v-radio>
              </v-radio-group>

              <v-menu v-else-if="col.isDatePicker" ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="itemDetail[col.value]" :label="col.text" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="itemDetail[col.value]" no-title @input="menu = false"></v-date-picker>
              </v-menu>

              <!-- <v-combobox v-else-if="col.value === 'tag'"
                  v-model="itemDetail[col.value]"
                  :items="tags"
                  :color="Theme.GREEN"
                  :label="col.text" multiple
                  hint="最多設定十個標籤"
                  chips
              ></v-combobox> -->
              <v-select v-else-if="col.options"
                        :color="Theme.GREEN"
                        :items="col.options"
                        :label="col.text"
                        :disabled="col.editLock"
                        item-text="value" item-value="key"
                        v-model="itemDetail[col.value]"/>
              <!-- todo 標籤選取欄位 -->
              <v-select v-else-if="tagList && col.value === 'tag'"
                v-model="itemDetail[col.value]"
                :items= "tagList"
                item-text="name"
                item-value="tagId"
                :label="col.text"
                multiple
                chips
                hint="最多設定十個標籤"
                persistent-hint
                :rules="[v => v.length <= 10 || '最多只能選擇十個標籤']"
              ></v-select>

              <v-text-field v-else-if="col.value === 'originPirce'"
                            v-model="itemDetail[col.value]"
                            :counter="col.max"
                            :label="col.text"
                            :disabled="col.disable"
                            :color="Theme.GREEN">
              </v-text-field>

              <v-switch v-else-if="col.isSwitch"
                  v-model="itemDetail[col.value]"
                        :label="col.text"
                        :color="Theme.GREEN"
              ></v-switch>
              <v-menu v-else-if="col.value === 'saleStartDate'"
                  ref="saleStartDateMenu"
                  v-model="saleStartDateMenu"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  :return-value="itemDetail[col.value]"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="itemDetail[col.value]"
                                :label="col.text"
                                :color="Theme.GREEN" readonly v-on="on"></v-text-field>
<!--                  <input :placeholder="col.text" class="textInput"-->
<!--                         :label="col.text"-->
<!--                         v-model="itemDetail[col.value]" readonly v-on="on">-->
                </template>
                <v-date-picker
                    v-model="itemDetail[col.value]" no-title
                    @input="changeDate(itemDetail[col.value])"
                    @change="changeDate(itemDetail[col.value])"
                    :color="Theme.GREEN" scrollable>
                </v-date-picker>
              </v-menu>
              <v-menu v-else-if="col.value === 'saleEndDate'"
                      ref="saleEndDateMenu"
                      v-model="saleEndDateMenu"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      :return-value="itemDetail[col.value]"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="itemDetail[col.value]"
                                :label="col.text"
                                :color="Theme.GREEN" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="itemDetail[col.value]" no-title
                    @input="changeDate(itemDetail[col.value])"
                    @change="changeDate(itemDetail[col.value])"
                    :color="Theme.GREEN" scrollable>
                </v-date-picker>
              </v-menu>




              <v-text-field v-else
                            v-model="itemDetail[col.value]"
                            :counter="col.max"
                            :label="col.text"
                            :disabled="col.disable"
                            :color="Theme.GREEN"></v-text-field>
              <img style="width: 25%;" v-if="col.isImage" :src="itemDetail[col.value]" />
            </v-flex>
          </v-layout>

<!--          <template v-if="(isAdmin || isStaff || userInfo.enablePriority === true)">-->
<!--            <v-divider class="mt-4 mb-4"/>-->
<!--            <h2>商品排序權重設定</h2>-->
<!--            <v-layout class="mt-2" row>-->
<!--              <v-flex>-->
<!--                <span><b style="color: #f6775e;">規則：從第二格開始，排序權重越高排越前面，權重與時效可累加，上限是20，如權重相同則以設定權重的時間快慢為準。</b></span>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
<!--            <v-layout class="mt-2" row>-->
<!--              <v-flex>-->
<!--                <span><b>目前排序權重：</b>{{ itemDetail.priority }} | 到期時間： {{ itemDetail.priorityEndTime }} </span>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
<!--            <v-layout row>-->
<!--              <v-flex class="flex-column">-->
<!--                <v-btn dark-->
<!--                       :loading="saveLoading"-->
<!--                       :color="Theme.GREEN"-->
<!--                       @click="addPriorityEvent(5)">-->
<!--                  權重+5 (代幣250/30hr)-->
<!--                </v-btn>-->
<!--                <v-btn dark class="ml-1"-->
<!--                       :loading="saveLoading"-->
<!--                       :color="Theme.GREEN"-->
<!--                       @click="addPriorityEvent(4)">-->
<!--                  權重+4 (代幣200/24hr)-->
<!--                </v-btn>-->
<!--                <v-btn dark class="ml-1"-->
<!--                       :loading="saveLoading"-->
<!--                       :color="Theme.GREEN"-->
<!--                       @click="addPriorityEvent(3)">-->
<!--                  權重+3 (代幣150/18hr)-->
<!--                </v-btn>-->
<!--                <v-btn dark class="ml-1"-->
<!--                       :loading="saveLoading"-->
<!--                       :color="Theme.GREEN"-->
<!--                       @click="addPriorityEvent(2)">-->
<!--                  權重+2 (代幣100/12hr)-->
<!--                </v-btn>-->
<!--                <v-btn dark class="ml-1"-->
<!--                       :loading="saveLoading"-->
<!--                       :color="Theme.GREEN"-->
<!--                       @click="addPriorityEvent(1)">-->
<!--                  權重+1 (代幣50/6hr)-->
<!--                </v-btn>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
<!--          </template>-->
          <v-divider class="mt-4 mb-4"/>
          <v-layout row>
            <v-flex xs12 md6>
              <v-text-field class="ml-2" v-model="productPriceInfo.draws"
                            label="抽數"
                            :color="Theme.GREEN"></v-text-field>
              <v-text-field class="ml-2" v-model="productPriceInfo.expectedProfitLower"
                            label="期望的價格下限(%)"
                            :color="Theme.GREEN"></v-text-field>
              <v-text-field class="ml-2" v-model="productPriceInfo.expectedProfitUpper"
                            label="期望的價格上限(%)"
                            :color="Theme.GREEN"></v-text-field>
              <v-btn dark
                  :color="Theme.GREEN"
                  @click="calculatePriceEvent">
                售價評估
              </v-btn>
            </v-flex>
            <v-flex xs12 md6>
              <ul>
                <li>
                  <span>每抽的成本: {{ productPriceInfo.costPerDraw }}</span>
                </li>
                <li>
                  <span>期望的每抽價格(下限 {{ productPriceInfo.expectedProfitLower }}%): {{ productPriceInfo.priceLowerLimit }}</span>
                </li>
                <li>
                  <span>期望的每抽價格(上限 {{ productPriceInfo.expectedProfitUpper }}%): {{ productPriceInfo.priceUpperLimit }}</span>
                </li>
                <li>
                  <span>促銷空間: {{ productPriceInfo.promotionalSpace }}</span>
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </div>
        <v-layout class="mt-2" v-if="tab === 1" row>
          <v-flex>
            <v-card class="mt-1">
              <v-card-text>
                <!-- todo 新增 上傳圖片按鈕 -->
                <v-layout class="ma-1">
                  <v-text-field v-model="itemDetail.imageUrl"
                                :label="`圖片網址(正方形 800px以上)`"
                                :color="Theme.GREEN">
                  </v-text-field>
                  <v-flex xs6 md3 class="ml-2" style="max-width: 98px; position: relative; cursor: pointer;">
                      <input type="file" @change="onFileChangeProduct($event, 'imageUrl')" style="position: absolute; inset: 0; z-index: 20; opacity: 0;">
                      <v-btn type="button" color="primary" style="position: relative;">上傳圖片</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout class="ma-1" v-if="itemDetail.imageUrl">
                  <img style="height: 200px;" :src="itemDetail.imageUrl" />
                </v-layout>

                <!-- * 商品圖片_泰文 -->
                <template v-if="isAdmin || isStaff">
                  <v-layout class="ma-1">
                    <v-text-field v-model="itemDetail.imageUrlTh"
                                  :label="`圖片網址_泰文(正方形 800px以上)`"
                                  :color="Theme.GREEN">
                    </v-text-field>
                    <v-flex xs6 md3 class="ml-2" style="max-width: 98px; position: relative; cursor: pointer;">
                      <input type="file" @change="onFileChangeProduct($event, 'imageUrlTh')" style="position: absolute; inset: 0; z-index: 20; opacity: 0;">
                      <v-btn type="button" color="primary" style="position: relative;">上傳圖片</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout class="ma-1" v-if="itemDetail.imageUrlTh">
                    <img style="height: 200px;" :src="itemDetail.imageUrlTh" />
                  </v-layout>
                </template>


                <v-layout class="ma-1">
                  <v-text-field v-model="itemDetail.introUrl"
                                :label="`介紹圖網址(可單張、建議長條圖)`"
                                :color="Theme.GREEN">
                  </v-text-field>
                  <v-flex xs6 md3 class="ml-2" style="max-width: 98px; position: relative; cursor: pointer;">
                      <input type="file" @change="onFileChangeProduct($event, 'introUrl')" style="position: absolute; inset: 0; z-index: 20; opacity: 0;">
                      <v-btn type="button" color="primary" style="position: relative;">上傳圖片</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout class="ma-1" v-if="itemDetail.introUrl">
                  <v-flex xs6><img style="max-height: 2000px;" :src="itemDetail.introUrl" /></v-flex>
                </v-layout>

                <!-- * 商品介紹圖_泰文 -->
                <template v-if="isAdmin || isStaff">
                  <v-layout class="ma-1">
                    <v-text-field v-model="itemDetail.introUrlTh"
                                  :label="`介紹圖網址_泰文(可單張、建議長條圖)`"
                                  :color="Theme.GREEN">
                    </v-text-field>
                    <v-flex xs6 md3 class="ml-2" style="max-width: 98px; position: relative; cursor: pointer;">
                      <input type="file" @change="onFileChangeProduct($event, 'introUrlTh')" style="position: absolute; inset: 0; z-index: 20; opacity: 0;">
                      <v-btn type="button" color="primary" style="position: relative;">上傳圖片</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout class="ma-1" v-if="itemDetail.introUrlTh">
                    <v-flex xs6><img style="max-height: 2000px;" :src="itemDetail.introUrlTh" /></v-flex>
                  </v-layout>
                </template>


              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout class="mt-2" v-if="tab === 2" row>
          <v-progress-circular v-if="loadingTicket" indeterminate :color="Theme.PINK"></v-progress-circular>
          <v-layout>
            <v-flex>
              <h3>已售完：{{ productSellCount }}抽
                | 累計贈送紅利： {{ productSellInfo.bonusTotal}}
                | 銷售總額： {{ productSellTotalPrice }}
                | 實收總額：<b style="color: #0B75A0">{{ productSellTotalPrice - productSellInfo.bonusTotal }}</b>
                <!-- 獲利=銷售總額-紅利總額 -->
                | 獲利：<b style="color: #0B75A0">{{ Number(productSellTotalPrice) - Number(totalRecyclePrice) }}</b>
                <!-- 獲利率=獲利/成本（紅利總額） x 100% -->
                | 獲利率：<b style="color: #0B75A0">{{ Number(totalRecyclePrice) !== 0 ? ((Number(productSellTotalPrice) - Number(totalRecyclePrice)) / Number(totalRecyclePrice) * 100).toFixed(0) : 'N/A' }}{{ Number(totalRecyclePrice) !== 0 ? '%' : '' }}</b>
              </h3>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 md3 class="mt-2 mb-2" v-for="ticket of productTickets" :key="ticket.tagId">
              <v-card >
                <v-card-title>籤號{{ ticket.tagSerialNumber }}</v-card-title>
                <v-card-text>
                  <span><b>抽出：</b>
                     <v-chip color="primary" v-if="ticket.tagCategory !==''">
                        {{ticket.tagCategory}}賞
                      </v-chip>
                  </span>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

        </v-layout>

        <v-layout column v-if="tab === 3">
          <v-flex>
            <v-btn dark :color="Theme.GREEN" @click="addPrize">新增</v-btn>
          </v-flex>
          <v-flex>
            <span class="mt-1" :style="`color: ${Theme.RED}`">*未建立抽獎券時才可以修改「賞品名稱」、「賞品類別」、「數量」、「刪除商品」，以避免爭議！</span>
            <br/>
            <span class="mt-1" :style="`color: ${Theme.RED}`">*賞品抽完就自動完售設定，如設定多組獎品，就要等有設定的都抽完才會變完售狀態！</span>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 3 && itemDetail.prizeList && itemDetail.prizeList.length > 0" row>
          <v-flex>
            <v-layout>
              <v-flex>
                <span class="heading">賞品總數：{{checkPrizeTotal}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;紅利總計: {{ totalRecyclePrice }}</span>
                <span v-if="itemDetail.category === 9">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;總出獎率: {{ totalProbability }}%</span>
              </v-flex>
            </v-layout>
            <v-card v-for="(item, i) in itemDetail.prizeList" :key="i" class="mt-1">
              <v-card-text>
                <!-- TODO 改成員工以上權限可以修改 -->
                <v-text-field v-model="item.name"
                              v-if="userInfo && (isAdmin || isStaff)"
                              :label="`#${i+1} 名稱`"
                              counter="32"
                              :color="Theme.GREEN">
                </v-text-field>
                <v-text-field v-model="item.name"
                              :label="`#${i+1} 名稱`"
                              v-else
                              :disabled="productTickets.length > 0"
                              counter="32"
                              :color="Theme.GREEN">
                </v-text-field>

                <template v-if="isAdmin || isStaff">
                  <v-text-field v-model="item.nameTh"
                                v-if="userInfo && (isAdmin || isStaff)"
                                :label="`#${i+1} 名稱_泰文`"
                                counter="200"
                                :color="Theme.GREEN">
                  </v-text-field>
                  <v-text-field v-model="item.nameTh"
                                :label="`#${i+1} 名稱_泰文`"
                                v-else
                                :disabled="productTickets.length > 0"
                                counter="200"
                                :color="Theme.GREEN">
                  </v-text-field>
                </template>


                <v-layout class="ma-1">
                  <v-flex>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-select v-if="itemDetail.category === 2"
                            :color="Theme.GREEN"
                            :items="blindBoxCategoryList"
                            label="盲盒類別"
                            :disabled="productTickets.length > 0"
                            @change="changePrizeCategory(i)"
                            v-model="item.category"/>
                        <v-select v-else
                            :color="Theme.GREEN"
                            :items="itemDetail.style === 0 ? prizeMoreCategoryList: prizeCategoryList"
                            label="賞品類別"
                            :disabled="productTickets.length > 0"
                            @change="changePrizeCategory(i)"
                            v-model="item.category"/>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-text-field class="ml-2" v-model="item.sort"
                                      type="number"
                                      counter="3"
                                      label="排序"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3 v-if="isAdmin || isStaff">
                        <v-select
                                  :color="Theme.GREEN"
                                  :items="getPrizeGroupList"
                                  label="群組"
                                  item-value="key"
                                  item-text="value"
                                  v-model="item.groupNo"/>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-select v-if="isAdmin || isStaff"
                            :color="Theme.GREEN"
                            :items="weightList"
                            label="體積"
                            v-model="item.weight"/>
                        <v-select v-else
                            :color="Theme.GREEN"
                            :items="item.count < 3 ? weightList: smallWeightList"
                            label="體積"
                            v-model="item.weight"/>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-select v-if="isAdmin || isStaff"
                            :color="Theme.GREEN"
                            :items="getPrizeCountList"
                            label="數量" :disabled="productTickets.length > 0"
                            v-model="item.count" @change="changePrizeCount(i)"/>
                        <v-select v-else
                            :color="Theme.GREEN"
                            :items="countList"
                            label="數量" :disabled="productTickets.length > 0"
                            v-model="item.count" @change="changePrizeCount(i)"/>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-text-field v-model="item.recyclePrice" type="number"
                                      v-if="(isAdmin || isStaff || isSpecialAccount) && item.category !== 3 "
                                      label="兌換紅利"
                                      :color="Theme.GREEN"></v-text-field>
                        <v-text-field v-model="item.recyclePrice" type="number"
                                      v-else
                                      :disabled="item.category !== 3 && productTickets.length > 0"
                                      label="兌換紅利"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3 v-if="(isAdmin || isStaff) && event === 'edit'">
                        <v-text-field v-model="item.productCode"
                                      label="SKU"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-select
                            :color="Theme.GREEN"
                            :items="item.count < 3 ? getDeliveryPriceList: 100"
                            label="商品運費"
                            v-model="item.deliveryPrice"/>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center v-if="(isAdmin && item.category !== 3 && item.category !== 5) && event === 'edit'">
                      <v-flex xs6 md3>
                        <v-text-field v-model="item.bonusLimit" type="number"
                                      label="幾抽內中獎"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-text-field v-model="item.bonus"
                                      label="幾抽內中獎額外紅利"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center v-if="((isAdmin || isStaff || isVendor)
                    && item.category !== 3  && item.category !== 5)">
                      <v-flex xs6 md3>

                        <v-checkbox v-if="userInfo && (isAdmin || isStaff)" v-model="item.specialPrize" label="是否為擊殺獎"></v-checkbox>
                        <v-checkbox v-else :disabled="productTickets.length > 0" v-model="item.specialPrize" label="是否為擊殺獎"></v-checkbox>
                      </v-flex>

                    <!-- 擊殺獎 > 只能變高不能改低 -->
                      <v-flex xs6 md3>
                        <v-text-field
                                      v-model="item.specialBonus"
                                      label="擊殺贈送紅利(會列入結算扣除)"
                                      type="number"
                                      :color="Theme.GREEN">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center v-if="(isSystem) && event === 'edit'">
                      <v-flex xs6 md3 >
                        <v-select
                            :color="Theme.GREEN"
                            :items="getLevelList"
                            label="Level"
                            v-model="item.level"/>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-checkbox v-model="item.enableAutoWin" label="Auto"></v-checkbox>
                      </v-flex>
<!--                      <v-flex xs6 md3 v-if="item.priorityLevel && item.priorityLevel > 0">-->
<!--                        <span>B Level: {{item.priorityLevel}}</span>-->
<!--                      </v-flex>-->
                    </v-layout>
                    <v-layout align-center v-if="(isSystem) && event === 'edit'">
                      <v-flex xs6 md3>
                        <v-checkbox v-model="item.enablePrizeCount" label="是否啟用剩餘抽數"></v-checkbox>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-text-field v-model="item.prizeCount"
                                      label="剩餘抽數"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <!-- * 增加 獎品設定 上傳圖片按鈕 -->
                    <v-layout align-center>
                        <v-flex xs6 md6>
                          <v-text-field v-model="item.imageUrl"
                                        label="賞品圖片"
                                        :color="Theme.GREEN"></v-text-field>
                        </v-flex>
                        <v-flex xs6 md3 class="ml-2" style="max-width: 98px; position: relative; cursor: pointer;">
                          <input type="file" @change="onFileChangePrice($event, i)" style="position: absolute; inset: 0; z-index: 20; opacity: 0;">
                          <v-btn type="button" color="primary" style="position: relative;">上傳圖片</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-checkbox v-model="item.enableOver" label="抽完此賞就完售"></v-checkbox>
                      </v-flex>
                      <v-flex xs6 md6>
                        <v-text-field v-model="item.storageName"
                                      label="儲位"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="isAdmin || isSystem">
                      <v-flex xs6 md3>
                        <v-checkbox v-model="item.privatePrize" label="不顯示於榜單"></v-checkbox>
                      </v-flex>
                    </v-layout>

                    <!-- * 新增 福袋分類商品特有 出獎率 probability -->
                    <v-layout v-if="itemDetail.category === 9">
                      <v-flex xs6 md3>
                        <v-text-field v-model="item.probability" label="出獎率 (%)" type="number" :color="Theme.GREEN" :disabled="productTickets.length > 0 && !isAdmin"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3 v-if="isSystem">
                        <v-text-field v-model="item.realProbability" label="出獎率 (%)" type="number" :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex>
                        <img style="height: 150px;" v-if="item.imageUrl" :src="item.imageUrl">
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-btn class="mr-2" :color="Theme.GREEN" v-if="event === 'edit'" dark @click="savePrizeInfo(i)">儲存</v-btn>
                        <v-btn class="mr-2" :color="Theme.RED" dark v-if="itemDetail.tickets === 0" @click="deletePrize(i)">刪除</v-btn>
                        <!-- 新增複製按鈕：點擊後複製該項目資料，但賞品類別不複製 -->
                        <v-btn color="primary" v-if="itemDetail.tickets === 0" @click="copyPrizeInfo(i)">複製</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-layout>
              <v-flex>
                <span class="heading">賞品總數：{{checkPrizeTotal}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;紅利總計: {{ totalRecyclePrice }}</span>
                <span v-if="itemDetail.category === 9">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;總出獎率: {{ totalProbability }}%</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 4" row>
          <v-flex>
            <v-progress-circular v-if="loadingTicket" indeterminate :color="Theme.PINK"></v-progress-circular>
            <div v-else>
              <span class="heading"
                    :style="`color:${Theme.RED}`">{{itemDetail.tickets === 0 ? '請建立抽獎籤！':`已設定完成！籤數：${itemDetail.tickets}`}}
              </span>

              <div v-if="itemDetail.tickets > 0">
                <div class="">排序方式：{{ itemDetail.sortDesc === 0 ? '正序' : '倒序' }}</div>
                <div class="" v-if="itemDetail.ignoreNumbers">排除號碼：{{ itemDetail.ignoreNumbers.slice(1, -1).split(',').join('、') }}</div>
              </div>

              <v-checkbox v-if="itemDetail.tickets === 0" v-model="shuffle" :color="Theme.GREEN" label="多洗牌一次 (系統初始分配完之後，再做一次洗牌)"></v-checkbox>
              <v-checkbox v-if="itemDetail.tickets === 0" v-model="sortDesc" :color="Theme.GREEN" label="倒序排列（例如 80~1 的順序顯示於畫面上）"></v-checkbox>

              <hr class="mb-3">
              <template v-if="userInfo.enableIgnoreNumbers && (userInfo.enableIgnoreNumbers === true || userInfo.enableIgnoreNumbers === 1)">
                <div v-if="productTickets.length === 0" class="mb-2" style="font-size: 18px;">自訂排除大獎號碼: 有效類別 A (總籤數大於 50 的話，每 10 抽可設定 1 個排除號碼，最多 5 個)</div>
                <!-- todo 藏簽 最多十個 -->
                <div v-if="productTickets.length === 0" class="mb-2">目前總籤數：{{ checkPrizeTotal }} <span v-if="checkPrizeTotal < 50" style="color: red; margin-left: 12px;">* 小於 50 張不提供排除號碼服務</span> </div>
                <!-- <div>hiddenTicketList.length: {{ hiddenTicketList.length }}</div> -->
                <div v-if="productTickets.length === 0 && checkPrizeTotal >= 50" class="mb-5">
                  <v-row v-for="(input, index) in hiddenTicketList" :key="index" style="align-items: center;">
                    <v-col cols="4">
                      <v-text-field v-model.number="hiddenTicketList[index]" label="排除大獎號碼" solo dense hide-details type="number"/>
                    </v-col>
                    <v-col cols="2">
                      <v-btn color="error" @click="removeHiddenTicket(index)">刪除號碼</v-btn>
                    </v-col>
                  </v-row>
                  <v-btn color="primary" @click="addHiddenTicket" :disabled="!canAddFields" class="mt-3">增加號碼欄位</v-btn>
                </div>

                <v-text
                    v-if="productTickets.length === 0 && checkEmptyStringInHiddenTicketList"
                    style="color: red;">
                  排除號碼不得為空值，請刪除空欄位後才能建立獎籤
                </v-text>
                <v-btn
                    v-else-if="productTickets.length === 0"
                    dark
                    :color="Theme.GREEN"
                    @click="createTicketsEvent">
                  建立獎籤
                </v-btn>
              </template>
              <template v-else>
                <v-btn
                    v-if="itemDetail.tickets === 0"
                    dark
                    :color="Theme.GREEN"
                    @click="createTicketsEvent"
                >
                  建立獎籤
                </v-btn>
              </template>

            </div>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 5" row>
          <v-flex>
            <v-layout>
              <v-flex>
                <v-btn :color="Theme.GREEN" dark v-if="productTickets.length === 0" @click="addReturnBonus()">新增</v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <span style="color: red">*數量不可相同</span>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <v-card v-for="(item, i) in returnBonus" :key="i" class="mt-1">
              <v-card-text>
                <v-layout class="ma-1">
                  <v-flex>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-select
                            :color="Theme.GREEN"
                            :items="countList"
                            label="滿幾抽"
                            v-model="item.count"/>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-text-field class="ml-2" v-model="item.bonus"
                                      label="送紅利x點"
                                      type="number"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-btn :color="Theme.RED" dark @click="deleteReturnBonus(i)">刪除</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-layout class="mt-2" v-if="returnBonus.length">
              <v-flex xs6 md3>
                <v-btn class="mr-2" :color="Theme.GREEN" v-if="event === 'edit'" :loading="saveLoading" dark @click="saveReturnBonusInfo()">儲存</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 6" row>
          <v-flex>
            <v-layout row>
              <v-progress-circular v-if="sendPrizeLoading" indeterminate :color="Theme.PINK"></v-progress-circular>
            </v-layout>
            <template v-if="itemDetail.status === 2">
              <h2>此商品已售完</h2>
            </template>
            <template v-else>
              <div>
                <v-layout row>
                  <v-flex xs12 md6>
                    <v-card style="margin: 10px;">
                      <v-card-text>
                        <v-text-field style="margin: 10px" label="會員Email(獲獎人)" v-model="sendUserEmail" :color="Theme.GREEN"></v-text-field>
                        <b style="margin: 6px;">{{selectPrizeText}}</b>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark :color="Theme.GREEN" :loading="sendPrizeSaveLoading" @click="sendPrizeEvent">贈獎</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex col12>
                    <v-checkbox v-model="selectAll" :label="`全選 (${sendPrizeList.length})`" @click="chooseAll"></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row>
                  <v-flex xs6 md3 class="mt-2 mb-2" v-for="(ticket, i) of sendPrizeList" :key="ticket.tagId">
                    <v-card style="height: 200px;">
                      <v-card-title>{{ticket.tagCategory}}賞</v-card-title>
                      <v-card-text>
                        <v-layout justify-center align-content-center m-2 row>
                          <v-flex md4>
                            <v-img style="width: 100px; height: 100px;" :src="ticket.imageUrl"></v-img>
                          </v-flex>
                          <v-flex md8>
                            <v-checkbox v-model="ticket.select" :label="ticket.name" @click="chooseSendPrize(i)"></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
            </template>

          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 7" row>
          <v-flex>
            <v-layout>
              <v-flex>
                <v-btn :color="Theme.GREEN" dark v-if="productTickets.length === 0" @click="addLevelPrice()">新增</v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <span style="color: red">*價格不可高於初始價</span>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <v-card v-for="(item, i) in levelPriceList" :key="i" class="mt-1">
              <v-card-text>
                <v-layout class="ma-1">
                  <v-flex>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-text-field class="ml-2" v-model="item.startCount"
                                      label="起始抽數"
                                      type="number"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-text-field class="ml-2" v-model="item.endCount"
                                      label="結束抽數"
                                      type="number"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-text-field class="ml-2" v-model="item.price"
                                      label="價格"
                                      type="number"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs6 md3>
                        <v-btn :color="Theme.RED" dark @click="deleteLevelPrice(i)">刪除</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-layout class="mt-2" v-if="levelPriceList.length">
              <v-flex xs6 md3>
                <v-btn class="mr-2" :color="Theme.GREEN" v-if="event === 'edit'" :loading="saveLoading" dark @click="saveLevelPriceInfo()">儲存</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 8" row>
          <v-flex>
            <v-data-table
              :headers="recentViewHeaders"
              :items="productRecentView"
              :items-per-page="10"
              :loading="loading"
              class="elevation-1"
            >
              <template v-slot:no-data>
                無瀏覽紀錄
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 9" row>
          <v-flex>
           <!-- *
            欄位

            名稱 bossName | varchar
            圖示 bossImageURL | varchar
            對話內容 tip | varchar
            最大血量 maxHealth | int
            獎品名稱 prizeName | varchar
            獎品圖示 prizeImageURL | varchar
            獎品數量 quantity | int
            傷害上限 damageLimit | int
            product/info
            增加回傳bossInfo
            -->
            <template v-if="bossInfo">
              <v-text-field v-model="bossInfo.bossName" label="Boss 名稱" :color="Theme.GREEN" :disabled="itemDetail.prizeList && itemDetail.tickets > 0"></v-text-field>

              <!-- Boss圖示上傳 -->
              <v-layout class="ma-1">
                <v-text-field v-model="bossInfo.bossImageURL"
                            label="Boss 圖示網址(正方形 800px以上)"
                            :color="Theme.GREEN"
                            :disabled="itemDetail.prizeList && itemDetail.tickets > 0">
                </v-text-field>
                <v-flex xs6 md3 class="ml-2" style="max-width: 98px; position: relative; cursor: pointer;">
                    <input type="file" @change="onFileChangeBoss($event, 'bossImageURL')" style="position: absolute; inset: 0; z-index: 20; opacity: 0;">
                    <v-btn type="button" color="primary" style="position: relative;" :disabled="itemDetail.prizeList && itemDetail.tickets > 0">上傳圖片</v-btn>
                </v-flex>
              </v-layout>
              <v-layout class="ma-1" v-if="bossInfo.bossImageURL">
                <img style="height: 200px;" :src="bossInfo.bossImageURL" />
              </v-layout>

              <v-text-field v-model="bossInfo.tip" label="Boss 對話內容" :color="Theme.GREEN" :disabled="itemDetail.prizeList && itemDetail.tickets > 0"></v-text-field>
              <v-text-field v-model.number="bossInfo.maxHealth" type="number" label="Boss 最大血量" :color="Theme.GREEN" :disabled="itemDetail.prizeList && itemDetail.tickets > 0" ></v-text-field>
              <v-text-field v-model.number="bossInfo.damageLimit" type="number" label="Boss 傷害上限" :color="Theme.GREEN" ></v-text-field>
              <v-text-field v-model="bossInfo.prizeName" label="獎品名稱" :color="Theme.GREEN" :disabled="itemDetail.prizeList && itemDetail.tickets > 0"></v-text-field>

              <!-- 獎品圖示上傳 -->
              <v-layout class="ma-1">
                <v-text-field v-model="bossInfo.prizeImageURL"
                            label="獎品圖示網址(正方形 800px以上)"
                            :color="Theme.GREEN"
                            :disabled="itemDetail.prizeList && itemDetail.tickets > 0">
                </v-text-field>
                <v-flex xs6 md3 class="ml-2" style="max-width: 98px; position: relative; cursor: pointer;">
                    <input type="file" @change="onFileChangeBoss($event, 'prizeImageURL')" style="position: absolute; inset: 0; z-index: 20; opacity: 0;">
                    <v-btn type="button" color="primary" style="position: relative;" :disabled="itemDetail.prizeList && itemDetail.tickets > 0">上傳圖片</v-btn>
                </v-flex>
              </v-layout>
              <v-layout class="ma-1" v-if="bossInfo.prizeImageURL">
                <img style="height: 200px;" :src="bossInfo.prizeImageURL" />
              </v-layout>

              <v-text-field v-model.number="bossInfo.quantity" type="number" label="獎品數量" :color="Theme.GREEN" :disabled="itemDetail.prizeList && itemDetail.tickets > 0"></v-text-field>
              <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="handleSaveBossInfo" :disabled="itemDetail.prizeList && itemDetail.tickets > 0">儲存 Boss 設定</v-btn>
            </template>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-btn v-if="(isAdmin || itemDetail.status === -1)" :loading="saveLoading" :color="Theme.RED" dark @click="deleteEvent">刪除</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';
export default {
  name: "product_detail",
  mixins: [common],
  props: {
    event: String,
    title:String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      returnBonus:[],
      levelPriceList:[],
      tags:[],
      saleStartDateMenu: false,
      saleEndDateMenu: false,
      saveLoading: false,
      content: '',
      editorOption: {
        placeholder:'商品詳細介紹'
      },
      tab: 0,
      defaultImageItem: {
        productId:'',
        url:'',
        sort:0,
      },
      defaultSpecItem: {
        productId:'',
        name: '',
        cost:0,
        price:0,
        salePrice: 0,
      },
      typeList:[],
      subtypeList: {},
      selectSubtypeList:[],
      selectType:'',
      selectSubType:'',
      samePrice: false,
      samePriceValue: '',
      sameSalePriceValue: '',
      sameCountValue: '',
      prizeInfo:{
        categoryId: '',
        productId:'',
        name:'',
        category: '',
        imageUrl:'',
        sort: 0,
        count: 0,
        weight: 1,
        recyclePrice: 0,
        productCode: '',
        deliveryPrice: 100,
        enableOver: false,
        level: 0,
        enableAutoWin: false,
        bonusLimit:0,
        bonus: 0,
        specialPrize: false,
        specialBonus: 0,
        prizeCount: 0,
        enablePrizeCount: false,
        privatePrize: false,
        groupNo: 0,
        storageName: ''
      },
      prizeCategoryList: ['SP','Last','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
      prizeMoreCategoryList: ['SP','Last','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'
      ,'1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20'],
      blindBoxCategoryList: ['SECRET1','SECRET2','SECRET3','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20'],
      countList: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40
      ,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80
      ,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100, 150, 250, 300, 500 ,750, 1000],
      smallWeightList: [1,2,3,4,5],
      weightList: [1, 2 ,5, 10, 20, 40, 60, 80, 90, 100, 120],
      checkPrizeTotal: 0,
      productTickets: [],
      productTicketCount: 0,
      loadingTicket : false,
      productPriceInfo: {
        costPerDraw: 0,
        priceLowerLimit: 0,
        priceUpperLimit: 0,
        promotionalSpace: 0,
        draws: 80,
        expectedProfitLower: 30,
        expectedProfitUpper: 40,
      },
      productSellCount: 0,
      productSellTotalPrice: 0,
      productSellInfo: {
        bonusTotal: 0,
        prizeList: []
      },
      sendPrizeLoading: false,
      sendPrizeSaveLoading: false,
      sendPrizeList: [],
      selectPrizeText: '',
      sendUserEmail: '',
      selectAll: false,
      userInfo: null,
      loadingUserInfo: false,
      shuffle: false,
      sortDesc: false,
      tagList: {},
      hiddenTicketList: [],
      vendorOptions: [],
      originalItemDetail: {}, // 用於存儲原始的 itemDetail
      productRecentView: [], // 商品近期瀏覽
      recentViewHeaders: [
        { text: '會員信箱', value: 'email', align: 'start' },
        { text: '暱稱', value: 'nickname' },
        { text: '瀏覽時間', value: 'createdDate' }
      ],
      bossInfo: {
        bossName: '',
        bossImageURL: '',
        tip: '',
        maxHealth: '',
        prizeName: '',
        prizeImageURL: '',
        quantity: '',
        damageLimit: ''
      },
    };
  },
  watch:{
    tab(value){
      console.log(`changeTab ${value}`);
      if (value === 0 || value === 2 || value === '2' || value === 4 || value === '4'){
        this.loadTickets();
        this.loadProductInfo();
        this.loadProductWinnerPrizeList();
      } else if (value === 6 || value === '6'){
        this.loadProductTicketPrizeList();
      }
    },
    visible(value){
      if (value){
        // this.loadProductTypeData();
        this.checkPrizeTotal = this.getPrizeCount();
        this.returnBonus = this.itemDetail.productReturnBonus ? this.itemDetail.productReturnBonus:[];
        this.levelPriceList = this.itemDetail.levelPriceList ? this.itemDetail.levelPriceList:[];
        if (this.event === 'edit'){
          this.loadTickets();
          this.loadProductInfo();
          this.loadProductWinnerPrizeList();
        }
        this.loadUserInfoEvent();
      }
    },
    // 'itemDetail.imageUrl': async function (value){
    //   if (value !== ''){
    //     const check = await this.checkIfSquareImage(value);
    //     if (check){
    //       this.itemDetail.imageUrl = value;
    //     } else {
    //       this.showMessageDialog('錯誤', '請使用400x400px以上正方形的圖片！')
    //     }
    //   }
    // },
    'itemDetail.tag': function(newVal) {
      // 在這裡處理 itemDetail.tag 的變化
      console.log('itemDetail.tag 已變化:', newVal);
    },
    // 觀察隱藏籤號列表的變化
    hiddenTicketList: {
      handler(newVal) {
        console.log('hiddenTicketList changed:', newVal);
      },
      deep: true,
    },
    checkPrizeTotal() {
      this.hiddenTicketList = [];
    },
    // 監聽 itemDetail 的 productId 變化, 如果 productId 有值, 則呼叫 loadProductRecentView
    itemDetail: {
      handler(newVal, oldVal) {
        // 增加判斷，確保只有 productId 真的改變時才執行
        if (newVal && newVal.productId && (!oldVal || newVal.productId !== oldVal.productId)) {
          this.loadProductRecentView();
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.loadTagData();
    this.loadVendorList();
  },
  mounted() {
    console.log('this is current quill instance object', this.editor);

    // 檢查 itemDetail 是否已經被初始化
    if (this.itemDetail && this.itemDetail.prizeList) {
      this.originalItemDetail = JSON.parse(JSON.stringify(this.itemDetail));
    } else {
      // 使用 watch 來監聽 itemDetail 的變化
      const unwatch = this.$watch('itemDetail', (newVal) => {
        if (newVal && newVal.prizeList) {
          this.originalItemDetail = JSON.parse(JSON.stringify(newVal));
          unwatch(); // 停止監聽
        }
      }, { immediate: true, deep: true });
    }
  },
  computed: {
    getSmallDeliveryPriceList(){
      let list = [];
      for (let i=100; i<=300 ; i+=10){
        list.push(i)
      }
      return list;
    },
    getDeliveryPriceList(){
      let list = [];
      for (let i=100; i<=600 ; i+=10){
        list.push(i)
      }
      return list;
    },
    getPrizeCountList(){
      let list = this.countList;
      list.push(1000);
      list.push(1500);
      list.push(2000);
      return list;
    },
    editor() {
      if (this.$refs.myQuillEditor) {
        return this.$refs.myQuillEditor.quill
      }
      return null;
    },
    getProductCategory(){
      return this.getCategoryList;
    },
    getLevelList(){
      let list = [];
      for (let i=0 ;i<=100 ; i++){
        list.push(i);
      }
      return list;
    },
    getDialogKeys() {
      let list = [];
      if (this.isAdmin || this.isStaff){
        list = [
          {value: 'productId', text: '系統商品編號' ,disable: true },
          {value: 'displayId', text: '自訂商品編號*' },
          {value: 'category', text: '分類*', options: this.getProductCategory },
          // {value: 'subtype', text: '子分類*' },
          {value: 'tag', text: '標籤', options: this.tagList.name},
          {value: 'name', text: '商品名稱*' , max: 32 },
          {value: 'nameTh', text: '商品名稱_泰文*' , max: 200 },
          {
            value: 'status', text: '銷售狀態', options: this.getProductEnable
          },
          // {value: 'color', text: '顏色'},
          // {value: 'tag', text: '自訂標籤'},
          {value: 'cost', text: '成本價', max: 6},
          ...(this.itemDetail.tickets > 0 ? [{value: 'originPrice', text: '初始價格', max: 5 }] : []),
          {value: 'price', text: '售價* (每抽價格)', max: 5, disable: this.itemDetail.category === 3
                && this.itemDetail.status !== -1
                && this.event === 'edit'},
          {value: 'firstSellPrice', text: '首抽價', max: 5},
          // {value: 'salePrice', text: '促銷價 > 0 時才會啟用'},
          // {value: 'saleStartDate', text: '促銷起始時間'},
          // {value: 'saleEndDate', text: '促銷結束時間'},
          {value: 'stock', text: '庫存數'},
          {value: 'onlyMarket', text: '限超取', isSwitch: true,},
          {value: 'onlyPost', text: '限郵局/黑貓', isSwitch: true,},
          {value: 'priority', text: '排序優先權重'},
          {value: 'ticketSortStyle', text: '獎籤排法', options: this.getTicketSortList, editLock: this.productTickets.length > 0},
          {
            value: 'style', text: '抽獎樣式', options: this.getLotteryStyle
          },
          {value: 'comment', text: '店家備註 (顯示在商品頁)', max: 100},
          {value: 'commentTh', text: '店家備註_泰文 (顯示在商品頁)', max: 1000},
          {value: 'stockType', text: '獎品現況', options: ['現貨','追加', '預購'], isRadio: true},
          {value: 'estimatedDeliveryDate', text: '預計出貨日期', isDatePicker: true},
          {value: 'endDate', text: '下架日期', isDatePicker: true},
          {value:'userId', text:'變更供應商', sortable: false, isSelect: true , options: this.vendorOptions },
          {value: 'enableDaily', text: '限每日僅能抽一抽', isSwitch: true,},
          {value: 'enableBuyAll', text: '是否能多抽', isSwitch: true,},
          {value: 'blindBoxCount', text: '盲盒數(盲盒產品才有效果)'},
          {value: 'startTime', text: '競標開始日期', isDatePicker: true},
          {value: 'endTime', text: '競標結束日期', isDatePicker: true},
          {value: 'startPrice', text: '起標價'},
          {value: 'bidIncrement', text: '最小出價金額'},
        ];
        if (this.isSystem){
          list.push({value: 'level', text: 'Level', options: this.getLevelList });
          list.push({value: 'enableAutoWin', text: 'Auto', isSwitch: true });
          list.push({value: 'chance', text: 'Chance', options: this.getLevelList });
          list.push({value: 'balanceList', text: '指定會員剩餘抽數(email)'});
        }
        if(this.isAdmin){
          // 新增保護時間 int & 跑馬燈顯示 bool
          list.push({value: 'protectTime', text: '保護時間'});
          list.push({value: 'marquee', text: '跑馬燈顯示', isSwitch: true});
        }
      } else {
        list = [
          {value: 'productId', text: '系統商品編號' ,disable: true },
          // {value: 'displayId', text: '自訂商品編號*' },
          {value: 'category', text: '分類*', options: this.getCategoryList },
          {value: 'tag', text: '標籤', options: this.tagList.name},
          {value: 'name', text: '商品名稱*', max: 32},
          // {value: 'nameTh', text: '商品名稱_泰文*' , max: 200 },
          {
            value: 'status', text: '銷售狀態', options: this.getProductEnable
          },
          {value: 'cost', text: '成本價', max: 6},
          ...(this.productTickets.length > 0 ? [{value: 'originPrice', text: '初始價格', max: 5, disable: true }] : []),
          {value: 'price', text: '售價*(每抽價格)', max: 5, disable: this.itemDetail.category === 3
                && this.itemDetail.status !== -1
                && this.event === 'edit'},
          // {value: 'firstSellPrice', text: '首抽價', max: 5},
          {value: 'stock', text: '庫存數'},
          {value: 'ticketSortStyle', text: '獎籤排法', options: this.getTicketSortList, editLock: this.productTickets.length > 0},
          {
            value: 'style', text: '抽獎樣式', options: this.getLotteryStyle
          },
          {value: 'comment', text: '店家備註 (顯示在商品頁)'},
          // {value: 'commentTh', text: '店家備註_泰文 (顯示在商品頁)', max: 1000},
          {value: 'stockType', text: '獎品現況', options: ['現貨','追加', '預購'], isRadio: true},
          {value: 'estimatedDeliveryDate', text: '預計出貨日期', isDatePicker: true},
          {value: 'endDate', text: '下架日期', isDatePicker: true},
        ];
      }
      return list;
    },
    tagNames() {
    return this.tagList.map(tag => tag.name);
    },
    // todo 檢查排除獎簽號碼有無空值
    checkEmptyStringInHiddenTicketList() {
      return this.hiddenTicketList.includes('');
    },
    // 計算總籤數，返回可以新增的排除號碼數量
    canAddFields() {
      if (this.checkPrizeTotal >= 50 && this.checkPrizeTotal < 59) {
        return this.hiddenTicketList.length < 1;
      } else if (this.checkPrizeTotal >= 60 && this.checkPrizeTotal < 69) {
        return this.hiddenTicketList.length < 2;
      } else if (this.checkPrizeTotal >= 70 && this.checkPrizeTotal < 79) {
        return this.hiddenTicketList.length < 3;
      } else if (this.checkPrizeTotal >= 80 && this.checkPrizeTotal < 89) {
        return this.hiddenTicketList.length < 4;
      } else if (this.checkPrizeTotal >= 100) {
        return this.hiddenTicketList.length < 5;
      }
      else {
        return this.hiddenTicketList.length === 0;
      }
    },
    // 計算 獎品設定 > 紅利總數
    totalRecyclePrice() {
      return this.itemDetail.prizeList.reduce((sum, item) => {
        return sum + (item.recyclePrice || 0) * (item.count || 1);
      }, 0);
    },
    // 計算 獎品設定 > 出獎率
    totalProbability() {
      if (!this.itemDetail?.prizeList) return 0;

      const total = this.itemDetail.prizeList.reduce((sum, item) => {
        // 確保 probability 是有效數字，否則使用 0
        const probability = !isNaN(parseFloat(item.probability)) ? parseFloat(item.probability) : 0;
        return sum + probability;
      }, 0);

      // 四捨五入到小數點後兩位
      return Number(total.toFixed(2));
    }
  },
  methods: {
    ...mapActions(['saveProductInfo','getTypeList','removeProductSpec'
      , 'getProductTickets', 'createProductTickets', 'saveProductPrize', 'saveProductReturnBonus', 'getProductWinnerInfo'
    ,'getProductTicketPrizeList', 'sendPrizeListToUser', 'updateProductPriority', 'loadUserInfo','deleteProductInfo', 'uploadFileV2'
      ,'getTagList', 'getVendorList', 'saveProductLevelPrice', 'getProductRecentView', 'getProductInfo', 'saveBossInfo',
    'getAdminProductInfo']),
    changeSelected(option){
      console.log(`changeSelectValue2 ${JSON.stringify(option)}`)
    },
    async loadVendorList(){
      try {
        const res = await this.getVendorList();
        const result = res.data;
        if (result.statusCode === 0){
          const vendorList = result.data;
          for (let vendor of vendorList){
            this.vendorOptions.push({ key: vendor.vendorId, value: vendor.name });
          }
          console.log(`vendorOptions = ${JSON.stringify(this.vendorOptions)}`);
        }
      } catch (e) {
        console.log(`getVendorList error `, e);
      }
    },
    async deleteEvent(){
      try {
        this.saveLoading = true;
        const res = await this.deleteProductInfo({
          isDelete: true,
          productId: this.itemDetail.productId,
        });

        if (res.data.statusCode === 0){
          this.$emit('confirmEvent', this.itemDetail);
        }
      } catch (e) {
        console.log(`deleteProductInfo error `, e);
      } finally {
        this.saveLoading = false;
      }
    },
    addPriorityEvent(priority){
      const self = this;
      this.showAlert({
        title: '提示',
        content: '確定要購買權重？ 此操作將不可退款！',
        confirmEvent: async () => {
          this.hideAlert();
          await self.saveProductPriority(priority);
        }
      });
    },
    async loadProductInfo(){
      try {
        this.loadingUserInfo = true;
        const res = await this.getAdminProductInfo({
          productId: this.itemDetail.productId,
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.productTickets = result.data.balanceTickets;
          this.itemDetail.tickets = this.productTickets;
          if (result.data.category !== 10 && this.productTickets === 0){
            if (this.productTickets === 0){
              this.itemDetail.tickets = 0;
            }
          }
          console.log(`this.productTickets == ${this.productTickets}`);
          console.log(`this.itemDetail.tickets == ${this.itemDetail.tickets}`);
          // 添加空值检查
          this.bossInfo = result.data.bossInfo || {
            bossName: '',
            bossImageURL: '',
            tip: '',
            maxHealth: '',
            prizeName: '',
            prizeImageURL: '',
            quantity: '',
          };
        }
      } catch (e) {
        console.log(`loadProductInfo error `, e);
      } finally {
        this.loadingUserInfo = false;
      }
    },
    async loadUserInfoEvent(){
      try {
        this.loadingUserInfo = true;
        const res = await this.loadUserInfo();
        const result = res.data;
        if (result && result.statusCode === 0){
          this.userInfo = result.data;
          console.log(`loadUserInfo == ${JSON.stringify(this.userInfo)}`);
        }
      } catch (e) {
        console.log(`loadUserInfo error `, e);
      } finally {
        this.loadingUserInfo = false;
      }
    },
    async saveProductPriority(priority){
      try {
        this.saveLoading = true;
        const res = await this.updateProductPriority({
          productId: this.itemDetail.productId,
          priority,
        });

        const result = res.data;
        if (result && result.statusCode === 0){
          this.showMessageDialog('提示', result.message);
          this.$emit('confirmEvent', this.itemDetail);
        } else {
          this.showMessageDialog('提示', result.message ? result.message: '購買失敗！');
        }

      } catch (e) {
        console.log(`sendPrizeEvent error `, e);
        this.showMessageDialog('提示', '發生錯誤！');
      } finally {
        this.saveLoading = false;
      }
    },
    async changePrizeCategory(i){
      if (this.event === 'edit'){
        if ( this.productTickets.length > 0) {
          console.log(`建立獎籤後不可改類別`)
          return;
        }
        await this.savePrizeInfo(i);
      }
    },
    async changePrizeCount(i){
      if (this.event === 'edit'){
        if ( this.productTickets.length > 0) {
          console.log(`建立獎籤後不可改數量`)
          return;
        }
        await this.savePrizeInfo(i);
      }
    },
    async sendPrizeEvent(){

      if (this.itemDetail.status !==-1){
        this.showMessageDialog('提示', '商品需要先下架才可使用手動贈獎!');
        return;
      }
      if (!this.sendUserEmail || this.sendUserEmail === ''){
        this.showMessageDialog('提示', '請輸入獲獎人Email!');
        return;
      }
      const list = this.sendPrizeList.filter(p=>p.select === true);
      if (!list || list.length === 0){
        this.showMessageDialog('提示', '請選擇要贈送的商品!');
        return;
      }

      const self = this;
      this.showAlert({
        title: '提示',
        content: '是否確定要贈送這些商品？ 此操作將不可復原！',
        confirmEvent: async () => {
          this.hideAlert();
          await self.sendPrizeData();
        }
      });
    },
    async sendPrizeData(){
      try {
        this.sendPrizeSaveLoading = true;
        let list = [];
        for (let prize of this.sendPrizeList){
          if (prize.select === true){
            list.push(prize);
          }
        }
        const res = await this.sendPrizeListToUser({
          productId: this.itemDetail.productId,
          prizeList: list,
          sendUserEmail: this.sendUserEmail.trim(),
        })
        const result = res.data;
        if (result && result.statusCode === 0){
          this.showMessageDialog('提示', result.message);
        } else {
          this.showMessageDialog('提示', result.message ? result.message: '贈獎失敗！');
        }
      } catch (e) {
        console.log(`sendPrizeEvent error `, e);
        this.showMessageDialog('提示', '贈獎發生錯誤！');
      } finally {
        this.sendPrizeSaveLoading = false;
        console.log(`finish loadProductTicketPrizeList`)
        await this.loadProductTicketPrizeList();
      }
    },
    chooseSendPrize(){
      let i = 0;
      let content = '';
      for (let ticket of this.sendPrizeList){
        if (ticket.select){
          content += `${ticket.name} `;
          i++;
        }
      }
      this.selectPrizeText = `已選擇 (${i}) 樣商品：${content}`;
      this.$forceUpdate();
    },
    chooseAll(){
      let i = 0;
      let content = '';
      for (let ticket of this.sendPrizeList){
        ticket.select = this.selectAll;
        if (ticket.select){
          content += `${ticket.name} `;
          i++;
        }
      }
      this.selectPrizeText = `已選擇 (${i}) 樣商品：${content}`;
      this.$forceUpdate();
    },
    addLevelPrice(){
      this.levelPriceList.push({
        productId: this.itemDetail.productId
      });
    },
    deleteLevelPrice(i){
      this.levelPriceList.splice(i , 1);
    },
    async saveLevelPriceInfo(){
      try {
        this.saveLoading = true;
        const res = await this.saveProductLevelPrice({
          productId: this.itemDetail.productId,
          levelPriceList: this.levelPriceList,
        });
        const result = res.data;
        if (result && result.message){
          this.showMessageDialog('提示', result.message);
        } else {
          this.showMessageDialog('錯誤', '儲存失敗');
        }
      }catch (e) {
        console.log(`saveReturnBonusInfo error ` , e);
        this.showMessageDialog('錯誤', '儲存失敗');
      } finally {
        this.saveLoading = false;
      }
    },
    addReturnBonus(){
      this.returnBonus.push({
        productId: this.itemDetail.productId
      });
    },
    deleteReturnBonus(i){
      this.returnBonus.splice(i , 1);
    },
    async saveReturnBonusInfo(){
      try {
        this.saveLoading = true;
        const res = await this.saveProductReturnBonus({
          productId: this.itemDetail.productId,
          returnBonus: this.returnBonus,
        });
        const result = res.data;
        if (result && result.message){
          this.showMessageDialog('提示', result.message);
        } else {
          this.showMessageDialog('錯誤', '儲存失敗');
        }
      }catch (e) {
        console.log(`saveReturnBonusInfo error ` , e);
        this.showMessageDialog('錯誤', '儲存失敗');
      } finally {
        this.saveLoading = false;
      }
    },
    changeDate(date){
      console.log(`changeDate == ${JSON.stringify(date)}`);
    },
    async loadProductTypeData(){
      const res = await this.getTypeList({});
      if (res.data.statusCode === 0) {
        const types = res.data.data;
        this.typeList = [];
        for (let type of types){
          this.typeList.push({ key: type.typeId, text: type.title });
          this.subtypeList[type.typeId] = type.subTypeList;
        }
        this.setSubTypeList();

        console.log(`getTypeList == ${JSON.stringify(this.typeList)}`);
        console.log(`subtypeList == ${JSON.stringify(this.subtypeList)}`);
      }
    },
    setSubTypeList(){
      if (this.itemDetail.category !==''){
        for (let type of this.subtypeList[this.itemDetail.category]){
          this.selectSubtypeList.push({ key: type.subId, text:type.name})
        }
      }
    },
    addImage(){
      const image = Object.assign({}, this.defaultImageItem);
      image.productId = this.itemDetail.productId;
      this.itemDetail.imageList.push(image);
    },
    addPrize(){
      const item = Object.assign({}, this.prizeInfo);
      item.productId = this.itemDetail.productId;
      item.sort = this.itemDetail.prizeList.length + 1;
      this.itemDetail.prizeList.push(item);
      this.$forceUpdate();
    },
    deleteImage(i){
      this.itemDetail.imageList.splice(i, 1);
    },
    async savePrizeInfo(i){
      const prize = this.itemDetail.prizeList[i];
      console.log(`savePrizeInfo == ${JSON.stringify(prize)}`);

      const originalPrize = this.originalItemDetail.prizeList[i]; // 取出原始資料
      console.log(`savePrizeInfo == ${JSON.stringify(prize)}`);

      // 檢查條件
      if (this.productTickets.length > 0 && !this.isAdmin && !this.isStaff) {
        console.log(`新的擊殺贈送紅利: ${prize.specialBonus}, 原始: ${originalPrize.specialBonus}`);

        if (prize.specialBonus < originalPrize.specialBonus) {
          this.showMessageDialog('警告', '新的擊殺贈送紅利不可比舊的低');
          return;
        }
      }

      try {
        const res = await this.saveProductPrize(prize);
        const result = res.data;
        if (result && result.message){
          this.showMessageDialog('提示', result.message);
          this.checkPrizeTotal = this.getPrizeCount();
          console.log(`savePrizeInfo success == ${JSON.stringify(result.data)}`);
          const prizeResult = result.data;
          if(prizeResult){
            // this.itemDetail.prizeList[i] = prizeResult;
            // 使用 $set 方法更新陣列中的特定項目
            this.$set(this.itemDetail.prizeList, i, prizeResult);

            // 更新 originalItemDetail
            this.$set(this.originalItemDetail.prizeList, i, JSON.parse(JSON.stringify(prizeResult)));
          }
        } else {
          this.showMessageDialog('錯誤', '儲存失敗');
        }
      } catch (e) {
        console.log(`savePrizeInfo error` , e);
        this.showMessageDialog('錯誤', '儲存失敗');
      }
    },
    async deletePrize(i){
      if (this.event === 'edit'){
        const item = this.itemDetail.prizeList[i];
        if (item.categoryId){
          const res = await this.removeProductSpec({ categoryId: item.categoryId });
          console.log(`removeProductSpec == ${JSON.stringify(res.data)}`);
        }
      }
      this.itemDetail.prizeList.splice(i, 1);
      this.checkPrizeTotal = this.getPrizeCount();
    },
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill);
      quill.container.style.height = '500px';
    },
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    async confirmEvent() {
      if (this.itemDetail.displayId === ''){
        this.showMessageDialog('錯誤', '請輸入自訂商品編號！');
        return false;
      }

      if (this.itemDetail.name === ''){
        this.showMessageDialog('錯誤', '請輸入商品名稱！');
        return false;
      }

      if (this.itemDetail.category === ''){
        this.showMessageDialog('錯誤', '請選擇主分類！');
        return false;
      }

      if (isNaN(this.itemDetail.price)){
        this.itemDetail.price = 0;
      }

      if (isNaN(this.itemDetail.firstSellPrice)){
        this.itemDetail.firstSellPrice = 0;
      }

      if (this.itemDetail.price === '' || this.itemDetail.price === 0){
        this.showMessageDialog('錯誤', '請設定售價！');
        return false;
      }

      // const check = await this.checkIfSquareImage(this.itemDetail.imageUrl);
      // if (!check){
      //   this.showMessageDialog('錯誤', '賞品列表圖片！請使用400x400px 以上正方形的圖片！')
      // }

      if (this.itemDetail.prizeList.length  === 0){
        this.showMessageDialog('錯誤', '請設定獎品！');
        return false;
      }

      // 檢查獎品設定
      let hasEmptyImage = false;
      let hasSameCategory = false;
      let checkCategory = {};
      for (let prize of this.itemDetail.prizeList){
        if (!checkCategory[prize.category]){
          checkCategory[prize.category] = {
            count : 1,
          }
        } else {
          checkCategory[prize.category].count +=1;
          hasSameCategory = true;
        }
      }
      console.log(`checkCategory = ${JSON.stringify(checkCategory)}`)
      if (hasSameCategory){
        this.showMessageDialog('錯誤', '賞品類別重複設定，請修正後再上架！');
        return false;
      }

      for (let prize of this.itemDetail.prizeList){
        if (prize.imageUrl === ''){
          hasEmptyImage = true;
          break;
        }
      }
      if (hasEmptyImage){
        this.showMessageDialog('錯誤', '請設定獎品圖片！');
        return false;
      }

      if (this.itemDetail.status === 1){
        if (this.itemDetail.tickets === 0){
          this.showMessageDialog('錯誤', '請先建立抽獎籤才能開賣！');
          return false;
        }
      }

      // if (this.itemDetail.specList.length > 0){
      //   let check = true;
      //   for (let item of this.itemDetail.specList){
      //     const checkValue = isNaN(item.price) ? 0 : item.price;
      //     console.log(`checkValue = ${checkValue}`);
      //     if (checkValue === '' || checkValue === 0){
      //       check = false;
      //       break;
      //     }
      //   }
      //   if(!check){
      //     this.showMessageDialog('錯誤', '請輸入商品規格售價！');
      //     return false;
      //   }
      // }


      if (isNaN(this.itemDetail.salePrice)){
        this.itemDetail.salePrice = 0;
      }

      if (isNaN(this.itemDetail.cost)){
        this.itemDetail.cost = 0;
      }

      if (isNaN(this.itemDetail.priority)){
        this.itemDetail.priority = 0;
      }

      // 將保護時間設定為數值
      this.itemDetail.protectTime = parseInt(this.itemDetail.protectTime);

      this.saveLoading = true;
      try {
        console.log(`save ${JSON.stringify(this.itemDetail)}`);
        const res = await this.saveProductInfo({ info: this.itemDetail });
        const result = res.data;
        this.saveLoading = false;
        if (result && result.statusCode === 0) {
          this.$emit('confirmEvent', this.itemDetail);
        } else {
          this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
        }
      } catch (e) {
        this.saveLoading = false;
        this.showMessageDialog('錯誤', `儲存失敗 ${e.message}`);
      }

    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
    getPrizeCount(){ // 不含最後賞
      let total = 0;
      for (let prize of this.itemDetail.prizeList){
        if (prize.category !=='Last'){
          total += prize.count;
        }
      }
      return total;
    },
    async loadTickets(){
      try {
        this.loadingTicket = true;
        this.productSellCount = 0;
        this.productTickets = [];

        const res = await this.getProductTickets({
          productId: this.itemDetail.productId
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.productTickets = result.data;
          this.itemDetail.tickets = this.productTickets.length;
          for (let ticket of this.productTickets){
            if (ticket.tagCategory && ticket.tagCategory !==''){
              this.productSellCount += 1;
            }
          }
          this.$forceUpdate();
          console.log(`productTickets = ${JSON.stringify(this.productTickets)}`);
        }
      } catch (e) {
        console.log(`getProductTickets error `, e);
      } finally {
        this.loadingTicket = false;
      }
    },
    async loadProductWinnerPrizeList(){
      try {
        const res = await this.getProductWinnerInfo({
          productId: this.itemDetail.productId
        });
        const result = res.data;
        if (result && result.statusCode === 0){
            this.productSellInfo = result.data;
            this.productSellTotalPrice = 0;
            for (let prize of this.productSellInfo.prizeList){
              this.productSellTotalPrice += prize.price;
            }
        }
      } catch (e) {
        console.log(`getProductWinnerInfo error `, e);
      }
    },
    async loadProductTicketPrizeList(){
      try {
        this.sendPrizeList = [];
        this.sendPrizeLoading = true;
        const res = await this.getProductTicketPrizeList({
          productId: this.itemDetail.productId
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.selectPrizeText = '';
          this.selectAll = false;
          this.sendPrizeList = result.data;
          for (let ticket of this.sendPrizeList){
            ticket.select = false;
          }
        }
        this.$forceUpdate();
      } catch (e) {
        console.log(`getProductWinnerInfo error `, e);
      } finally {
        this.sendPrizeLoading = false;
      }
    },
    async createTicketsEvent(){
      const self = this;
      this.showAlert({
        title: '提示',
        content: '建立獎籤之前，務必確認賞品總數是否正確！建立獎籤後將不可再刪除賞品！！',
        confirmEvent: async () => {
          this.hideAlert();
          await self.createTickets();
        }
      });
    },
    async createTickets(){
      // 福袋商品 > 檢查出獎率 === 100%
      if (this.itemDetail.category === 9){
        if (this.totalProbability !== 100){
          this.showMessageDialog('錯誤', '出獎率必須為 100%');
          return;
        }
      }

      try {
        let prizes = {};
        for (let prize of this.itemDetail.prizeList){
          if (this.itemDetail.category === 2) { // 盲盒不重複
            prizes[prize.category] = 1;
          } else {
            prizes[prize.category] = prize.count;
          }
        }
        console.log(`hiddenTicketList = ${JSON.stringify(this.hiddenTicketList)}`);
        console.log(`prizes = ${JSON.stringify(prizes)}`);
        const res = await this.createProductTickets({
          productId: this.itemDetail.productId,
          shuffle: this.shuffle,
          sortDesc: this.sortDesc,
          ignoreNumbers: this.hiddenTicketList,
          prizes
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          await this.loadTickets();
          this.showMessageDialog('提示', '建立成功');
        } else {
          this.showMessageDialog('錯誤', '建立失敗');
        }
      } catch (e) {
        this.showMessageDialog('錯誤', '建立失敗');
      }
    },
    calculatePriceEvent(){
      const cost = parseInt(this.itemDetail.cost);
      if (isNaN(cost) || cost === 0){
        this.showMessageDialog('提示', '請輸入成本！');
        return;
      }

      const draws = this.productPriceInfo.draws;
      const expectedProfitLower = this.productPriceInfo.expectedProfitLower;
      const expectedProfitUpper = this.productPriceInfo.expectedProfitUpper;
      const result = this.calculatePrice(cost, draws, expectedProfitLower, expectedProfitUpper);
      this.productPriceInfo.costPerDraw = result.costPerDraw;
      this.productPriceInfo.priceLowerLimit = result.priceLowerLimit;
      this.productPriceInfo.priceUpperLimit = result.priceUpperLimit;
      this.productPriceInfo.promotionalSpace = result.promotionalSpace;
    },
    calculatePrice(cost, draws, expectedProfitLower, expectedProfitUpper){
      const costPerDraw = cost / draws;
      const priceLowerLimit = costPerDraw * (1 + expectedProfitLower / 100);
      const priceUpperLimit = costPerDraw * (1 + expectedProfitUpper / 100);

      const promotionalSpace = priceUpperLimit - priceLowerLimit;

      return {
        costPerDraw: costPerDraw.toFixed(2),
        priceLowerLimit: priceLowerLimit.toFixed(2),
        priceUpperLimit: priceUpperLimit.toFixed(2),
        promotionalSpace: promotionalSpace.toFixed(2)
      };
    },
    getImageSizeAsync(url) {
      return new Promise((resolve, reject) => {
        let img = new Image();

        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };

        img.onerror = () => {
          reject(new Error('無法加載圖片'));
        };

        img.src = url;
      });
    },
    async checkIfSquareImage(url) {
      try {
        let size = await this.getImageSizeAsync(url);
        if (size.width === size.height) {
          console.log('這個圖片是正方形。');
          return true;
        } else {
          console.log('這個圖片不是正方形。');
          return false;
        }
      } catch (error) {
        console.error(error.message);
        return false;
      }
    },
    // 觸發 選擇檔案後上傳圖片 -> 獎品設定的圖片
    onFileChangePrice(e, i) {
      const file = e.target.files[0];
      if (file) {
        // console.log(`File name: ${file.name}`);
        // console.log(`File size: ${file.size}`);
        // console.log(`File type: ${file.type}`);
        this.uploadImagePrice(file,i);
      }
    },
    // 把圖片存到 firebase, 將回傳的 url 更新到 itemDetail
    async uploadImagePrice(file, i) {
      const formData = new FormData();
      formData.append('image', file);

      try {
        this.saveLoading = true;
        const res = await this.uploadFileV2(formData);

        const result = res.data;
        console.log(`uploadImage == ${JSON.stringify(result)}`);
        if (result && result.statusCode === 0){
          this.showMessageDialog('提示', result.message);
          this.itemDetail.prizeList[i].imageUrl = result.data.url;
        } else {
          this.showMessageDialog('提示', result.message ? result.message: '上傳失敗');
        }

      } catch (e) {
        console.log(`sendPrizeEvent error `, e);
        this.showMessageDialog('提示', '發生錯誤！');
      } finally {
        this.saveLoading = false;
      }
    },
    // 觸發 選擇檔案後上傳圖片 -> 商品圖片的圖片, type 決定是哪個欄位
    onFileChangeProduct(e, type) {
      const file = e.target.files[0];
      if (file) {
        // console.log(`File name: ${file.name}`);
        // console.log(`File size: ${file.size}`);
        // console.log(`File type: ${file.type}`);
        this.uploadImageProduct(file, type);
      }
    },
    // 把圖片存到 firebase, 將回傳的 url 更新到 itemDetail
    async uploadImageProduct(file, type) {
      const formData = new FormData();
      formData.append('image', file);

      try {
        this.saveLoading = true;
        const res = await this.uploadFileV2(formData);

        const result = res.data;
        console.log(`uploadImage == ${JSON.stringify(result)}`);
        if (result && result.statusCode === 0){
          this.showMessageDialog('提示', result.message);
          if( type === 'imageUrl'){
            this.itemDetail.imageUrl = result.data.url;
          } else if (type === 'imageUrlTh'){
            this.itemDetail.imageUrlTh = result.data.url;
          } else if (type === 'introUrl'){
            this.itemDetail.introUrl = result.data.url;
          } else if (type === 'introUrlTh'){
            this.itemDetail.introUrlTh = result.data.url;
          }
        } else {
          this.showMessageDialog('提示', result.message ? result.message: '上傳失敗');
        }

      } catch (e) {
        console.log(`sendPrizeEvent error `, e);
        this.showMessageDialog('提示', '發生錯誤！');
      } finally {
        this.saveLoading = false;
      }
    },
    // 載入 標籤資料
    async loadTagData() {
      try {
        this.loading = true;
        const res = await this.getTagList();
        if (res.data.statusCode === 0) {
          // console.log(`getTagList ${JSON.stringify(res.data.data)}`);
          this.tagList = res.data.data;
          // console.log(`tagList ${JSON.stringify(this.tagList)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getTagList error`, e.stack);
      }
    },
    // 藏簽的輸入框
    addHiddenTicket() {
      this.hiddenTicketList.push('');
    },
    removeHiddenTicket(index) {
      this.hiddenTicketList.splice(index, 1);
    },
    // 複製獎品
    async copyPrizeInfo(index) {
      const originalItem = this.itemDetail.prizeList[index];
      const copiedItem = JSON.parse(JSON.stringify(originalItem)); // 使用深拷貝

      // 保留產品 ID
      copiedItem.productId = this.itemDetail.productId;

      // 設置新的排序值
      copiedItem.sort = this.itemDetail.prizeList.length + 1;

      // 重置欄位
      copiedItem.category = '';
      copiedItem.categoryId = '';
      copiedItem.productCode = '';

      // 添加複製的項目到列表中
      this.itemDetail.prizeList.push(copiedItem);

      // 強制更新視圖
      this.$forceUpdate();

      // 提示用戶新項目已添加，需要保存
      this.showMessageDialog('提示', '新獎品項目已複製。請記得選取類別後點擊「儲存」按鈕來保存更改。');
    },
    // 取得商品 近期瀏覽 > 參數 productId
    async loadProductRecentView(){
      try {
        this.loading = true;
        let productId = this.itemDetail?.productId

        console.log(`this.itemDetail = ${JSON.stringify(this.itemDetail)}`);
        console.log(`this.itemDetail?.productId = ${this.itemDetail?.productId}`);
        console.log(`productId = ${JSON.stringify(productId)}`);

        const res = await this.getProductRecentView(productId);
        console.log(`loadProductRecentView res = ${JSON.stringify(res)}`);

        if (res.data.statusCode === 0) {
          this.productRecentView = res.data.data;
          console.log(`productRecentView = ${JSON.stringify(this.productRecentView)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getProductRecentView error`, e.stack);
      }
    },
    /**
     * 儲存 Boss 設定
     */
    async handleSaveBossInfo() {
      try {
        this.saveLoading = true;
        // 确保maxHealth和quantity是数值类型
        const bossData = {
          ...this.bossInfo,
          maxHealth: Number(this.bossInfo.maxHealth) || 0,
          quantity: Number(this.bossInfo.quantity) || 0,
          damageLimit: Number(this.bossInfo.damageLimit) || 0,
          productId: this.itemDetail.productId
        };

        console.log(`bossData == ${JSON.stringify(bossData)}`);

        const res = await this.saveBossInfo(bossData);
        if (res.data.statusCode === 0){
          this.showMessageDialog('提示', '儲存成功');
          this.loadProductInfo();
        } else {
          this.showMessageDialog('提示', '儲存失敗');
        }
      } catch (e) {
        this.showMessageDialog('提示', '儲存失敗');
      } finally {
        this.saveLoading = false;
      }
    },
    // 把圖片存到 firebase, 將回傳的 url 更新到 bossInfo
    async onFileChangeBoss(e, type) {
      const file = e.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('image', file);

        try {
          this.saveLoading = true;
          const res = await this.uploadFileV2(formData);

          const result = res.data;
          console.log(`uploadImage == ${JSON.stringify(result)}`);
          if (result && result.statusCode === 0){
            this.showMessageDialog('提示', result.message);
            this.bossInfo[type] = result.data.url;
          } else {
            this.showMessageDialog('提示', result.message ? result.message: '上傳失敗');
          }

        } catch (e) {
          console.log(`uploadImage error `, e);
          this.showMessageDialog('提示', '發生錯誤！');
        } finally {
          this.saveLoading = false;
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
